import * as React from "react";
import type { SVGProps } from "react";
const SvgSun = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#sun_svg__a)">
      <path d="M12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8m0-6a2 2 0 1 0 0 4 2 2 0 0 0 0-4M12 7a1 1 0 0 1-1-1V3a1 1 0 0 1 2 0v3a1 1 0 0 1-1 1M12 22a1 1 0 0 1-1-1v-3a1 1 0 0 1 2 0v3a1 1 0 0 1-1 1M6 13H3a1 1 0 0 1 0-2h3a1 1 0 0 1 0 2M21 13h-3a1 1 0 0 1 0-2h3a1 1 0 0 1 0 2M5.64 19.36a1 1 0 0 1-.71-.29 1 1 0 0 1 0-1.41l2.12-2.12a1 1 0 0 1 1.41 0 1 1 0 0 1 0 1.41l-2.12 2.12a1 1 0 0 1-.7.29M16.24 8.76a1 1 0 0 1-.7-.3 1 1 0 0 1 0-1.41l2.12-2.12a1 1 0 0 1 1.41 0 1 1 0 0 1 0 1.41L17 8.46a1 1 0 0 1-.76.3M18.36 19.36a1 1 0 0 1-.7-.29L15.54 17a1 1 0 0 1 0-1.41 1 1 0 0 1 1.41 0l2.12 2.12a1 1 0 0 1 0 1.41 1 1 0 0 1-.71.24M7.76 8.76a1 1 0 0 1-.71-.3L4.93 6.34a1 1 0 0 1 0-1.41 1 1 0 0 1 1.41 0l2.12 2.12a1 1 0 0 1 0 1.41 1 1 0 0 1-.7.3" />
    </g>
    <defs>
      <clipPath id="sun_svg__a">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSun;
